// extracted by mini-css-extract-plugin
module.exports =  {"ShortDescriptionField":"ShortDescriptionField__nDRrp","readOnly":"readOnly__CYmV5"};